/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(11265);module.exports = "../../app/cells/components/banner/signup_banner/show.erb";

/***/ }),

/***/ 40158:
/***/ ((module) => {

module.exports = "../../app/cells/components/banner/signup_banner_cell.rb";

/***/ }),

/***/ 79752:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/leaderboard/show.erb";

/***/ }),

/***/ 53:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/leaderboard_cell.rb";

/***/ }),

/***/ 51036:
/***/ ((module) => {

module.exports = "../../app/cells/components/handle_title_segment/show.erb";

/***/ }),

/***/ 27310:
/***/ ((module) => {

module.exports = "../../app/cells/components/handle_title_segment_cell.rb";

/***/ }),

/***/ 356:
/***/ ((module) => {

module.exports = "../../app/cells/pages/exams/cta_exams_list/show.erb";

/***/ }),

/***/ 12465:
/***/ ((module) => {

module.exports = "../../app/cells/pages/exams/cta_exams_list_cell.rb";

/***/ }),

/***/ 11265:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"LMdkPcjQFRlkuqTwWIOU","relative":"zwk5ILldSn2jMmPziZia","fixed":"PdCIKMUwTZJCRJcAd7dg","orange":"bDbB4ZveAnqHtZCa_spJ","black":"CHVpEcJJ1zSK9cIuafKQ","close":"xJZm4F7Au4HMKkuUAAEE"});

/***/ }),

/***/ 23216:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 37946:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 64622:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 34163:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 41911:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 3209:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 39187:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 11686:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 3111:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./pages/exams/components/cta_exams_list/index.erb
var cta_exams_list = __webpack_require__(356);
// EXTERNAL MODULE: ./pages/exams/components/cta_exams_list/index.rb
var components_cta_exams_list = __webpack_require__(12465);
;// CONCATENATED MODULE: ./pages/exams/components/cta_exams_list/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/exams/components/cta_exams_list/index.js




;// CONCATENATED MODULE: ./pages/exams/components/exam_item/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/exams/components/exam_item/index.js


;// CONCATENATED MODULE: ./pages/exams/components/exams_filter_form/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./components/select/index.js + 9 modules
var components_select = __webpack_require__(86325);
// EXTERNAL MODULE: ./utils/autofill_by_query_string/index.js
var autofill_by_query_string = __webpack_require__(19682);
// EXTERNAL MODULE: ./utils/filter_form/index.js
var filter_form = __webpack_require__(65917);
// EXTERNAL MODULE: ./utils/form_data_summary/index.js
var form_data_summary = __webpack_require__(55310);
;// CONCATENATED MODULE: ./pages/exams/components/exams_filter_form/index.js





(function($) {
    const $filterForm = $('#js-exams-filter-form');
    $filterForm.filterForm().formDataSummary('.js-summary').autoFillByQueryString().lazyReady();
})(window.jQuery);

;// CONCATENATED MODULE: ./pages/exams/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./components/banner/signup_banner/index.erb
var signup_banner = __webpack_require__(6170);
// EXTERNAL MODULE: ./components/banner/signup_banner/index.rb
var banner_signup_banner = __webpack_require__(40158);
;// CONCATENATED MODULE: ./components/banner/signup_banner/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


const SIGNUP_BANNER_EVENT = 'account created banner';
const SIGNUP_BANNER_EXCEPT = [
    'user',
    'iterable',
    'appcues'
];
class SignupBanner {
    init() {
        this.close.on('click', (e)=>window.jQuery(e.currentTarget).parent().hide());
        this.button.on('click', (e)=>{
            const button = window.jQuery(e.currentTarget);
            const isDataEmit = button.attr('data-emit') || false;
            const flag = button.attr('data-flag') || 'flag-default';
            const theme = button.attr('data-theme') || 'theme-default';
            const position = button.attr('data-position') || 'position-default';
            if (isDataEmit) {
                this.dispatchTrackerEvent('clicked', {
                    flag,
                    theme,
                    position
                });
            }
        });
    }
    dispatchTrackerEvent(event, params = {}) {
        const data = {
            eventName: `${SIGNUP_BANNER_EVENT} ${event}`,
            except: SIGNUP_BANNER_EXCEPT,
            data: _extends({}, params)
        };
        try {
            UserTracker.emit('event', data);
        } catch (error) {
            Rollbar.error('dispatchTrackerEvent', error);
        }
    }
    constructor(){
        this.close = window.jQuery('#js-signup-banner-close');
        this.button = window.jQuery('#js-signup-banner');
    }
}
(()=>{
    new SignupBanner().init();
})();

// EXTERNAL MODULE: ./components/campaigns/interventions/leaderboard/index.erb
var leaderboard = __webpack_require__(79752);
// EXTERNAL MODULE: ./components/campaigns/interventions/leaderboard/index.rb
var interventions_leaderboard = __webpack_require__(53);
;// CONCATENATED MODULE: ./components/campaigns/interventions/leaderboard/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/campaigns/interventions/leaderboard/index.js




// EXTERNAL MODULE: ./components/handle_title_segment/index.erb
var handle_title_segment = __webpack_require__(51036);
// EXTERNAL MODULE: ./components/handle_title_segment/index.rb
var components_handle_title_segment = __webpack_require__(27310);
;// CONCATENATED MODULE: ./components/handle_title_segment/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/handle_title_segment/index.js



const segmentsPath = [
    'questoes-de-concursos',
    'questoes-militares',
    'questoes-da-oab',
    'questoes-do-enem',
    'questoes-de-vestibular'
];
const segmentsName = {
    'questoes-de-concursos': 'Concursos',
    'questoes-militares': 'Militares',
    'questoes-da-oab': 'OAB',
    'questoes-do-enem': 'ENEM',
    'questoes-de-vestibular': 'Vestibular'
};
class HandleTitleSegment {
    init() {
        this.activateSegmentButton();
        this.addClickEventToButtons();
        this.redirectToSegment();
        this.toggleModal();
    }
    toggleModal() {
        this.$toogleModalButtons.on('click', ()=>{
            if (this.$modal.hasClass('hidden')) {
                this.openModal();
                return;
            }
            this.closeModal();
        });
    }
    openModal() {
        this.$modal.removeClass('hidden');
        window.jQuery('body').addClass('q-select-no-scroll');
    }
    closeModal() {
        this.$modal.addClass('hidden');
        this.setToInitialSegment();
        window.jQuery('body').removeClass('q-select-no-scroll');
    }
    setBaseUrl() {
        const url = new URL(window.location.href);
        return url.origin;
    }
    hasSegment() {
        const url = new URL(window.location.href);
        const segment = url.pathname.split('/')[1];
        if (segmentsPath.includes(segment)) {
            return segment;
        } else {
            return null;
        }
    }
    pathnameWithoutSegment() {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/').filter((part)=>part && !segmentsPath.includes(part));
        return '/' + pathParts.join('/');
    }
    activateSegmentButton() {
        this.$buttons.each((i, button)=>{
            const $button = window.jQuery(button);
            if ($button.data('segment') === this.dynamicSegment) {
                $button.addClass('active');
            } else {
                $button.removeClass('active');
            }
        });
    }
    addClickEventToButtons() {
        this.$buttons.on('click', (event)=>{
            const $button = window.jQuery(event.target);
            const segment = $button.data('segment');
            this.handleButtonClick(segment);
        });
    }
    setToInitialSegment() {
        if (this.initialSegment === this.dynamicSegment) {
            return;
        }
        this.dynamicSegment = this.initialSegment;
        this.activateSegmentButton();
    }
    handleButtonClick(segment) {
        if (segment === this.dynamicSegment) {
            return;
        }
        this.dynamicSegment = segment;
        this.activateSegmentButton();
    }
    redirectToSegment() {
        const url = new URL(window.location.href);
        const urlSegment = url.pathname.split('/')[1];
        this.$submitButton.on('click', ()=>{
            if (this.dynamicSegment === urlSegment) {
                this.$modal.addClass('hidden');
            } else {
                const url = `${this.baseUrl}/${this.dynamicSegment}${this._pathnameWithoutSegment}`;
                this.trackEvents();
                Turbolinks.visit(url);
            }
        });
    }
    trackEvents() {
        UserTracker.emit('event', {
            eventName: 'study segment changed',
            data: {
                'initial segment': segmentsName[this.initialSegment],
                'final segment': segmentsName[this.dynamicSegment]
            }
        });
    }
    constructor(component){
        this.baseUrl = this.setBaseUrl();
        this.initialSegment = this.hasSegment();
        this.dynamicSegment = this.hasSegment();
        this._pathnameWithoutSegment = this.pathnameWithoutSegment();
        this.component = component;
        this.$buttons = window.jQuery('#buttons-container button');
        this.$toogleModalButtons = window.jQuery('.js-toggle-modal');
        this.$submitButton = window.jQuery('#submit-button');
        this.$modal = window.jQuery('#js-handle-segment-modal');
        this.$segmentTitle = window.jQuery('#segment-title');
        this.init();
    }
}
const $components = window.jQuery('.js-handle-title-segment');
$components.each((i, component)=>new HandleTitleSegment(component));

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/map.js
var map = __webpack_require__(96799);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__(86759);
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);
;// CONCATENATED MODULE: ./utils/ajax_component_loader/index.js
function ajax_component_loader_extends() {
    ajax_component_loader_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return ajax_component_loader_extends.apply(this, arguments);
}


class AjaxComponentLoader {
    static _request($target, component, params, data, resolve, reject) {
        window.jQuery.ajax({
            url: `/components/${component}?${window.jQuery.param(params)}`,
            method: 'POST',
            data,
            success: (res)=>AjaxComponentLoader._success($target, component, res, resolve),
            error: (res)=>AjaxComponentLoader._fail(component, res, reject)
        });
    }
    static _success($target, component, res, cb) {
        if ($target) {
            $target.html(res).addClass('q-component-loaded');
            window.permissions.bindClicks($target);
        }
        if (typeof cb === 'function') cb(res);
        window.jQuery(document).trigger(`componentLoaded:${component}`, {
            context: $target
        });
    }
    static _fail(component, res, cb) {
        if (res.status === 401) {
            SessionExpired.renewSessionModal(location.pathname);
        } else if (res.status !== 0) {
            AjaxComponentLoader.reportToRollbar(component, res);
            if (typeof cb === 'function') cb(res);
        }
    }
    static load(config) {
        const authenticity_token = window.jQuery('body').data('authenticity-token');
        const { target, component, asset_key, type, data_type, params = {} } = config;
        const $target = target ? window.jQuery(target) : null;
        const data = Object.keys(config.data).reduce((cur, key)=>{
            cur[snakeCase_default()(key)] = config.data[key];
            return cur;
        }, {});
        params.current_product = data.product_key ? data.product_key : 'concursos';
        let requestData = ajax_component_loader_extends({}, params, {
            data,
            asset_key,
            authenticity_token,
            data_type: data_type || 'hash',
            type: type || 'component'
        });
        return new Promise((resolve, reject)=>{
            AjaxComponentLoader._request($target, component, params, requestData, resolve, reject);
        });
    }
    static reportToRollbar(component, res) {
        Rollbar.error(`AjaxComponentLoader: Erro ao carregar o componente "${component}"`, {
            serverStatusText: res.statusText,
            serverStatus: res.status,
            responseText: res.responseText,
            component: component
        });
    }
}


// EXTERNAL MODULE: ./utils/serialize_object/index.js
var serialize_object = __webpack_require__(49539);
;// CONCATENATED MODULE: ./utils/modal_manager/index.js

class ModalManager {
    static bindForm($modal, callback) {
        const $form = window.jQuery('form', $modal);
        if (!$form.length) {
            return;
        }
        $form.off('submit.form').on('submit.form', (e)=>{
            e.preventDefault();
            const formData = $form.serializeObject();
            $modal.modal('hide');
            callback(formData, window.jQuery(e.currentTarget));
            $form.clearForm();
        });
    }
    static populate(selector, data) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        for(const itemName in data){
            const $element = $modalElement.find(`[data-modal-${itemName}]`);
            const value = data[itemName];
            if ($element.is('button')) {
                value ? $element.show() : $element.hide();
            }
            if ($element.attr('value') !== undefined) {
                $element.val(value);
            } else {
                $element.html(value);
            }
        }
    }
    static bindButtons($modal, callback) {
        window.jQuery('#js-ok-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(true);
            }
        });
        window.jQuery('#js-cancel-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(false);
            }
        });
    }
    static dispatchEvents(selector) {
        const eventName = {
            '#modal-id': 'event name'
        }[selector];
        if (eventName === undefined) {
            return;
        }
        UserTracker.emit('event', {
            eventName
        });
    }
    static open(selector, callback) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        const $modal = $modalElement.modal();
        const isCallbackEnabled = callback && typeof callback === 'function';
        if (isCallbackEnabled) {
            ModalManager.bindForm($modal, callback);
        }
        ModalManager.bindButtons($modal, isCallbackEnabled ? callback : null);
        ModalManager.dispatchEvents(selector);
        $modal.modal('show');
        return $modal;
    }
    static close($modal) {
        $modal.modal('hide');
    }
}
/* harmony default export */ const modal_manager = (ModalManager);

;// CONCATENATED MODULE: ./utils/session_expired/index.js


class SessionExpired {
    static renewSessionModal(return_url) {
        AjaxComponentLoader.load({
            component: 'modals/session_expired_modal',
            type: 'component',
            data: {
                return_url: return_url
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            if (gon.flags.session_expired_debug) {
                UserTracker.emit('event', {
                    eventName: 'expired session',
                    data: {
                        request_path: window.location.pathname,
                        cookie_my_app_session: Boolean(window.currentUser),
                        cookie_remember_user_token: Boolean(window.currentUser)
                    }
                });
            }
            modal_manager.open('#js-session-expired-modal');
        }).catch(()=>{
            Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        });
    }
}


;// CONCATENATED MODULE: ./utils/api_error_handler/index.js

function handleApiError(message, error) {
    if ((error == null ? void 0 : error.status) === 401) {
        SessionExpired.renewSessionModal(location.href);
    } else {
        toastr.error(message || 'Ocorreu um erro, tente novamente.');
        if (!(error == null ? void 0 : error.errors)) {
            return Rollbar.error(message, error);
        }
        const errors = Object.keys(error.errors);
        if (errors.length) {
            const errorKey = errors[0];
            const errorMsgs = error.errors[errorKey];
            const errorMsg = errorMsgs.length && errorMsgs[0] || '';
            Rollbar.error(`API response error${errorMsg && `: ${errorKey} ${errorMsg}`}.`, {
                status: error.status,
                statusText: error.statusText,
                responseText: error.responseText
            });
        }
    }
}

;// CONCATENATED MODULE: ./utils/stored_filters/index.js


const StoredFilters = {
    segmentFilters: {
        8: {
            _availableFilters: {
                q: 'keyword',
                by_examining_board: 'examining_boards_ids',
                by_institute: 'institutes_ids',
                by_year: 'years',
                by_states: 'states_ids',
                by_situation: 'situations_ids'
            },
            _reverseTranslation: {
                keyword: 'q',
                examining_boards_ids: 'by_examining_board',
                institutes_ids: 'by_institute',
                years: 'by_year',
                states_ids: 'by_states',
                situations_ids: 'by_situation'
            }
        },
        7: {
            _availableFilters: {
                q: 'keyword',
                discipline_ids: 'disciplines_ids',
                subject_ids: 'subjects_ids',
                examining_board_ids: 'examining_boards_ids',
                institute_ids: 'institutes_ids',
                scholarity_ids: 'scholarities_ids',
                has_professor_commentaries: 'commented_by_professor',
                has_commentaries: 'commented_by_users',
                with_my_commentaries: 'commented',
                with_my_annotations: 'annotated',
                exclude_from_notebooks: 'excluding_my_notebooks',
                exclude_from_practice_tests: 'exclude_from_practice_tests',
                knowledge_area_ids: 'knowledge_areas_ids',
                job_ids: 'jobs_ids',
                publication_year: 'years',
                administrative_level_ids: 'administrative_levels_ids',
                modality_ids: 'modalities_ids',
                difficulty: 'difficulty_levels_ids',
                my_questions: 'my_questions',
                exclude_nullified: 'exclude_nullified',
                exclude_outdated: 'exclude_outdated',
                exam_ids: 'exams_ids'
            },
            _reverseTranslation: {
                keyword: 'q',
                disciplines_ids: 'discipline_ids',
                subjects_ids: 'subject_ids',
                examining_boards_ids: 'examining_board_ids',
                institutes_ids: 'institute_ids',
                scholarities_ids: 'scholarity_ids',
                commented_by_professor: 'has_professor_commentaries',
                commented_by_users: 'has_commentaries',
                commented: 'with_my_commentaries',
                annotated: 'with_my_annotations',
                excluding_my_notebooks: 'exclude_from_notebooks',
                exclude_from_practice_tests: 'exclude_from_practice_tests',
                knowledge_areas_ids: 'knowledge_area_ids',
                jobs_ids: 'job_ids',
                years: 'publication_year',
                administrative_levels_ids: 'administrative_level_ids',
                modalities_ids: 'modality_ids',
                difficulty_levels_ids: 'difficulty',
                my_questions: 'my_questions',
                exclude_nullified: 'exclude_nullified',
                exclude_outdated: 'exclude_outdated',
                exams_ids: 'exam_ids'
            }
        },
        3: {
            _availableFilters: {
                q: 'keyword',
                by_institute: 'institutes_ids',
                by_examining_board: 'examining_boards_ids',
                application_year: 'years',
                by_job: 'jobs_ids',
                by_scholarity: 'scholarities_ids',
                by_administrative_level: 'administrative_levels_ids',
                by_knowledge_area: 'knowledge_areas_ids',
                online: 'online'
            },
            _reverseTranslation: {
                keyword: 'q',
                institutes_ids: 'by_institute',
                examining_boards_ids: 'by_examining_board',
                years: 'application_year',
                jobs_ids: 'by_job',
                scholarities_ids: 'by_scholarity',
                administrative_levels_ids: 'by_administrative_level',
                knowledge_areas_ids: 'by_knowledge_area',
                online: 'online'
            }
        }
    },
    save (name, product, segment, serialized, $button) {
        this.serialized = serialized;
        const source_project = 1;
        Thor.StoredFilter.create({}, {
            data: this.prepareRequest(name, product, segment, source_project)
        }).then(()=>{
            toastr.success('Filtro salvo com sucesso!');
            UserTracker.emit('event', {
                eventName: 'stored filter created',
                data: this.getEventData()
            });
            if ($button) {
                $button.attr('disabled', true);
            }
        }).catch((error)=>{
            error.response.json().then((response)=>{
                const errors = response.errors;
                if (errors.subjects_ids) {
                    toastr.error(errors.subjects_ids[0]);
                } else {
                    if (errors.name) {
                        toastr.error(errors.name[0]);
                    } else {
                        if ((errors == null ? void 0 : errors.user_id) && (errors == null ? void 0 : errors.user_id[0])) {
                            handleApiError(errors.user_id[0], response);
                        } else {
                            handleApiError('Ops! Não foi possível criar o seu filtro nesse momento!', response);
                        }
                    }
                }
            });
        });
    },
    prepareQuery (filters) {
        const queryStringKeys = {};
        queryStringKeys['stored_filter_id'] = filters['id'];
        for(const key in filters){
            const correctKey = this.segmentFilters[filters.segment_id]._reverseTranslation[key];
            let value = filters[key];
            if (correctKey && value && String(value).length > 0) {
                if (Array.isArray(value) && typeof value[0] === 'object') {
                    value = map_default()(value, 'id');
                }
                queryStringKeys[correctKey] = value;
            }
        }
        return window.jQuery.param(queryStringKeys);
    },
    prepareRequest (name, product, segment_id, source_project) {
        return {
            product,
            segment_id,
            stored_filter: window.jQuery.extend(this.translateParams(segment_id), {
                name
            }),
            source_project
        };
    },
    translateParams (segment_id, params = this.serialized) {
        let translatedParams = {};
        for(const key in params){
            const value = params[key];
            const correctKey = this.segmentFilters[segment_id]._availableFilters[key];
            if (correctKey && value && (typeof value === 'boolean' || value.length > 0)) {
                translatedParams[correctKey] = value;
            }
        }
        return translatedParams;
    },
    getEventData () {
        const { pathname } = location;
        const pagesList = {
            concursos: 'contest',
            questoes: 'question',
            provas: 'exam'
        };
        const pageName = pathname.split('/').pop();
        const type = pagesList[pageName];
        return {
            type
        };
    }
};
/* harmony default export */ const stored_filters = (StoredFilters);

// EXTERNAL MODULE: ./utils/filter_form/options/track.js
var track = __webpack_require__(89571);
;// CONCATENATED MODULE: ./components/modals/new_filter_modal/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/modals/new_filter_modal/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





(function($) {
    'use strict';
    const handleSuggestion = (segmentId)=>{
        const $suggestionBox = $('#js-new-filter-modal .q-suggestion-box');
        const $loadingBox = $('#js-new-filter-modal .q-suggestion-loading');
        $suggestionBox.hide();
        $loadingBox.hide();
        if ($suggestionBox.length === 0 || segmentId !== 7) return;
        $loadingBox.show();
        const data = new track/* default */.Z("#js-questions-filter-form").parse();
        let magicName = "";
        const request = fetch('https://niamh.grupoq.io/api/concursos/stored_filters/name', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        request.then(/*#__PURE__*/ _async_to_generator(function*(response) {
            const body = yield response.json();
            magicName = body.result.name;
        })).finally(()=>{
            if (magicName.length > 0) {
                $('#js-new-filter-modal .q-suggestion-name').text(magicName);
                $loadingBox.hide();
                $suggestionBox.show().animate({
                    opacity: 1
                }, 600, function() {
                    setTimeout(()=>{
                        $(this).css('box-shadow', 'none').css('animation', 'none');
                    }, 4000);
                });
            }
        });
    };
    $('.js-filter-form').on('click', '.js-btn-save', (event)=>{
        const $button = $(event.currentTarget);
        const { segmentId, product, limitReached } = $button.data();
        if (limitReached === true) return;
        handleSuggestion(segmentId);
        UserTracker.emit('event', {
            eventName: 'stored filter creation started'
        });
        modal_manager.open('#js-new-filter-modal', (formData, $formEvent)=>{
            const name = $formEvent.find('[name="filter-name"]').val();
            const serialized = $('.js-filter-form').serializeObject();
            stored_filters.save(name, product, segmentId, serialized, $button);
        });
    });
    $('#js-new-filter-modal').on('click', '.q-suggestion-box', (event)=>{
        UserTracker.emit('event', {
            eventName: 'stored filter suggestion name used'
        });
        const suggestion = $('.q-suggestion-name').text();
        const $input = $('#js-new-filter-modal').find('[name="filter-name"]');
        $input.val(suggestion);
    });
})(window.jQuery);

;// CONCATENATED MODULE: ./styles/components/_alerts.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./styles/components/_pagination.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/exams/index.js











;// CONCATENATED MODULE: ./packs/exams.js



/***/ }),

/***/ 49539:
/***/ (() => {

/* eslint-disable no-prototype-builtins */ (function($) {
    $.fn.serializeObject = function(castValues = true, alwaysReturnKeys = false) {
        let self = this, json = {}, push_counters = {}, patterns = {
            'validate': /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
            'key': /[a-zA-Z0-9_]+|(?=\[\])/g,
            'push': /^$/,
            'fixed': /^\d+$/,
            'named': /^[a-zA-Z0-9_]+$/
        };
        this.isJsonString = function(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        };
        this.castValues = (obj)=>{
            // eslint-disable-next-line no-unused-vars
            for(const key in obj){
                if (!obj.hasOwnProperty(key)) continue;
                let value = obj[key];
                if (typeof value === 'undefined' || value === null || value.toString().length === 0) continue;
                if (typeof value === 'object') {
                    value = this.castValues(value);
                } else if (value === 'true') {
                    value = true;
                } else if (value === 'false') {
                    value = false;
                } else if (!isNaN(value)) {
                    value = parseFloat(value);
                } else if (this.isJsonString(value)) {
                    value = JSON.parse(value);
                }
                obj[key] = value;
            }
            return obj;
        };
        this.build = function(base, key, value) {
            if (alwaysReturnKeys || value && value.toString().length) base[key] = value;
            return base;
        };
        this.push_counter = function(key) {
            if (push_counters[key] === undefined) {
                push_counters[key] = 0;
            }
            return push_counters[key]++;
        };
        $.each($(this).serializeArray(), function() {
            // skip invalid keys
            if (!patterns.validate.test(this.name)) {
                return;
            }
            let k, keys = this.name.match(patterns.key), merge = this.value, reverse_key = this.name;
            while((k = keys.pop()) !== undefined){
                // adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');
                if (k.match(patterns.push)) {
                    merge = self.build([], self.push_counter(reverse_key), merge);
                } else if (k.match(patterns.fixed)) {
                    merge = self.build([], k, merge);
                } else if (k.match(patterns.named)) {
                    merge = self.build({}, k, merge);
                }
            }
            json = $.extend(true, json, merge);
        });
        return castValues ? this.castValues(json) : json;
    };
})(window.jQuery);


/***/ }),

/***/ 53609:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseForOwn = __webpack_require__(14996), createBaseEach = __webpack_require__(69897);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;


/***/ }),

/***/ 57798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__(60329);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;


/***/ }),

/***/ 14996:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFor = __webpack_require__(57798), keys = __webpack_require__(55543);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;


/***/ }),

/***/ 53048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseEach = __webpack_require__(53609), isArrayLike = __webpack_require__(70879);
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;


/***/ }),

/***/ 69897:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(70879);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) {
            return collection;
        }
        if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
        }
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) {
                break;
            }
        }
        return collection;
    };
}
module.exports = createBaseEach;


/***/ }),

/***/ 60329:
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
                break;
            }
        }
        return object;
    };
}
module.exports = createBaseFor;


/***/ }),

/***/ 96799:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__(94292), baseIteratee = __webpack_require__(95280), baseMap = __webpack_require__(53048), isArray = __webpack_require__(8388);
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			6635: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [6759,5280,1106,9187,6325,7859], () => (__webpack_require__(3111)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;